/** @jsx jsx */

import { jsx } from '@emotion/core';

export const Certificate_3_SVG = props => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 2084 1471.6"
      xmlSpace="preserve"
    >
      <g id="Change_colour">
        <polygon
          style={{
            fill: '#00CBC3',
          }}
          points="77.1,60.3 60.5,60.3 60.5,76.9 60.5,338.9 60.5,638.9 60.5,912.8 60.5,1092 60.5,1130.7    60.5,1394.2 60.5,1410.9 77.1,1410.9 890.9,1410.9 926.7,1410.9 947.7,1410.9 1137,1410.9 1158.1,1410.9 1193.8,1410.9    2006.5,1410.9 2023.2,1410.9 2023.2,1394.2 2023.2,1130.7 2023.2,1094.6 2023.2,915.5 2023.2,643 2023.2,344.6 2023.2,60.3  "
        />
      </g>
      <g id="Foreground">
        <path
          style={{
            opacity: 0.9,
            fill: '#FFFFFF',
          }}
          d="M77.1,338.9C77.1,338.9,77.1,338.9,77.1,338.9c10.3,53.9,90.8,436.4,338.3,729.7   c7.7-0.4,15.5-0.8,23.3-1.2c6.6-0.3,13.2-0.6,19.9-1c0.5,0,1,0,1.4-0.1c7.7-0.4,15.4-0.7,23.1-1.1c30.7-1.4,61.9-2.6,93.3-3.8   c6.5-0.2,13.1-0.5,19.7-0.7c98-3.4,199.3-5.7,303.3-6.7c1.1,0,9.1-0.1,17.1-0.1c0.2-1.7,0.1-3.4-0.3-5.1c-0.1-0.3-0.1-0.5-0.2-0.8   l-1.2-4.3c-2.4-8.7,2.8-17.7,11.5-19.9l4.3-1.1c6.7-1.7,11.5-7.5,12-14.4l0.3-4.4c0.7-9,8.6-15.7,17.6-14.8l4.4,0.4   c6.8,0.7,13.4-3.1,16.2-9.4l1.8-4.1c3.7-8.2,13.4-11.8,21.6-7.9l4,1.9c6.2,3,13.7,1.7,18.5-3.2l3.1-3.2c6.3-6.5,16.7-6.5,23,0   l3.1,3.2c4.8,4.9,12.2,6.2,18.5,3.2l4-1.9c8.2-3.9,17.9-0.4,21.6,7.9l1.8,4.1c2.9,6.3,9.4,10.1,16.2,9.4l4.4-0.4   c9-0.9,16.9,5.8,17.6,14.8l0.4,4.4c0.5,6.9,5.4,12.7,12,14.4l4.3,1.1c8.8,2.2,13.9,11.2,11.5,19.9l-1.2,4.3   c-0.2,0.6-0.2,1.2-0.3,1.7c-0.2,1.5-0.3,3-0.1,4.4c4,0,8.6,0.1,13.2,0.2c171,2.6,334.8,7.4,487.6,15.7c0,0,0,0,0,0   c241.2-284.7,324.3-654.4,338.5-725.4V76.9H77.1V338.9z"
        />
        <g>
          <path
            style={{
              fill: '#241F20',
            }}
            d="M515.5,415.2c6.2-10.9,14.7-19.3,25.4-25.4c10.7-6.1,22.8-9.1,36.1-9.1c15.6,0,29.3,4,41,12    c11.7,8,19.9,19.1,24.6,33.2h-32.2c-3.2-6.7-7.7-11.7-13.5-15c-5.8-3.3-12.5-5-20.1-5c-8.1,0-15.4,1.9-21.7,5.7    c-6.3,3.8-11.3,9.2-14.8,16.1c-3.5,6.9-5.3,15.1-5.3,24.4c0,9.2,1.8,17.3,5.3,24.3c3.5,7,8.5,12.4,14.8,16.2    c6.3,3.8,13.6,5.7,21.7,5.7c7.6,0,14.3-1.7,20.1-5.1c5.8-3.4,10.3-8.4,13.5-15.1h32.2c-4.7,14.3-12.8,25.4-24.5,33.3    c-11.7,7.9-25.4,11.9-41.1,11.9c-13.3,0-25.4-3-36.1-9.1c-10.7-6.1-19.2-14.5-25.4-25.3c-6.2-10.8-9.3-23.1-9.3-36.8    C506.2,438.4,509.3,426.1,515.5,415.2z"
          />
          <path
            style={{
              fill: '#241F20',
            }}
            d="M770.2,475.2h-81.1c0.7,8,3.5,14.3,8.4,18.8c4.9,4.5,11,6.8,18.2,6.8c10.4,0,17.8-4.5,22.2-13.4    h30.2c-3.2,10.7-9.3,19.4-18.4,26.3c-9.1,6.9-20.2,10.3-33.4,10.3c-10.7,0-20.2-2.4-28.7-7.1c-8.5-4.7-15.1-11.4-19.8-20.1    c-4.7-8.7-7.1-18.7-7.1-30c0-11.5,2.3-21.5,7-30.2c4.7-8.7,11.2-15.3,19.6-20c8.4-4.7,18.1-7,29-7c10.5,0,20,2.3,28.3,6.8    c8.3,4.5,14.8,11,19.4,19.3c4.6,8.3,6.9,17.9,6.9,28.7C771,468.4,770.7,472,770.2,475.2z M741.9,456.3c-0.1-7.2-2.7-13-7.8-17.3    c-5.1-4.3-11.3-6.5-18.6-6.5c-6.9,0-12.8,2.1-17.5,6.3c-4.7,4.2-7.6,10-8.7,17.5H741.9z"
          />
          <path
            style={{
              fill: '#241F20',
            }}
            d="M834.7,414.7c5.8-3.3,12.4-5,19.9-5v29.4h-7.4c-8.8,0-15.4,2.1-19.9,6.2    c-4.5,4.1-6.7,11.3-6.7,21.6v55.2h-28V411.3h28v17.2C824.2,422.7,828.9,418.1,834.7,414.7z"
          />
          <path
            style={{
              fill: '#241F20',
            }}
            d="M907.2,434.3V488c0,3.7,0.9,6.4,2.7,8.1c1.8,1.7,4.8,2.5,9.1,2.5h13v23.6h-17.6    c-23.6,0-35.4-11.5-35.4-34.4v-53.4h-13.2v-23H879v-27.4h28.2v27.4h24.8v23H907.2z"
          />
          <path
            style={{
              fill: '#241F20',
            }}
            d="M955.4,393.4c-3.3-3.1-4.9-7-4.9-11.7s1.6-8.6,4.9-11.7c3.3-3.1,7.4-4.7,12.3-4.7    c4.9,0,9,1.6,12.3,4.7c3.3,3.1,4.9,7,4.9,11.7s-1.6,8.6-4.9,11.7c-3.3,3.1-7.4,4.7-12.3,4.7C962.7,398.1,958.6,396.5,955.4,393.4z     M981.5,411.3v110.9h-28V411.3H981.5z"
          />
          <path
            style={{
              fill: '#241F20',
            }}
            d="M1061.1,434.3h-19.4v87.9h-28.4v-87.9h-12.6v-23h12.6v-5.6c0-13.6,3.9-23.6,11.6-30    c7.7-6.4,19.4-9.4,35-9v23.6c-6.8-0.1-11.5,1-14.2,3.4c-2.7,2.4-4,6.7-4,13v4.6h19.4V434.3z"
          />
          <path
            style={{
              fill: '#241F20',
            }}
            d="M1082.5,393.4c-3.3-3.1-4.9-7-4.9-11.7s1.6-8.6,4.9-11.7c3.3-3.1,7.4-4.7,12.3-4.7    c4.9,0,9,1.6,12.3,4.7c3.3,3.1,4.9,7,4.9,11.7s-1.6,8.6-4.9,11.7c-3.3,3.1-7.4,4.7-12.3,4.7    C1089.8,398.1,1085.7,396.5,1082.5,393.4z M1108.6,411.3v110.9h-28V411.3H1108.6z"
          />
          <path
            style={{
              fill: '#241F20',
            }}
            d="M1137.2,436.6c4.7-8.6,11.1-15.3,19.4-20c8.3-4.7,17.7-7.1,28.4-7.1c13.7,0,25.1,3.4,34.1,10.3    c9,6.9,15,16.5,18.1,28.9H1207c-1.6-4.8-4.3-8.6-8.1-11.3c-3.8-2.7-8.5-4.1-14.1-4.1c-8,0-14.3,2.9-19,8.7c-4.7,5.8-7,14-7,24.7    c0,10.5,2.3,18.7,7,24.5c4.7,5.8,11,8.7,19,8.7c11.3,0,18.7-5.1,22.2-15.2h30.2c-3.1,12-9.1,21.5-18.2,28.6    c-9.1,7.1-20.4,10.6-34,10.6c-10.7,0-20.1-2.4-28.4-7.1c-8.3-4.7-14.7-11.4-19.4-20c-4.7-8.6-7-18.6-7-30.1    C1130.2,455.3,1132.5,445.2,1137.2,436.6z"
          />
          <path
            style={{
              fill: '#241F20',
            }}
            d="M1258.6,436.5c4.5-8.7,10.5-15.3,18.2-20c7.7-4.7,16.2-7,25.7-7c8.3,0,15.5,1.7,21.7,5    c6.2,3.3,11.2,7.5,14.9,12.6v-15.8h28.2v110.9h-28.2V506c-3.6,5.2-8.6,9.5-14.9,12.9c-6.3,3.4-13.6,5.1-21.9,5.1    c-9.3,0-17.8-2.4-25.5-7.2c-7.7-4.8-13.7-11.6-18.2-20.3c-4.5-8.7-6.7-18.8-6.7-30.1C1251.9,455.1,1254.1,445.2,1258.6,436.5z     M1335.1,449.2c-2.7-4.9-6.3-8.6-10.8-11.2c-4.5-2.6-9.4-3.9-14.6-3.9c-5.2,0-10,1.3-14.4,3.8c-4.4,2.5-8,6.2-10.7,11.1    c-2.7,4.9-4.1,10.6-4.1,17.3c0,6.7,1.4,12.5,4.1,17.5c2.7,5,6.3,8.8,10.8,11.5c4.5,2.7,9.2,4,14.3,4c5.2,0,10.1-1.3,14.6-3.9    c4.5-2.6,8.1-6.3,10.8-11.2c2.7-4.9,4-10.7,4-17.5C1339.1,459.9,1337.8,454.1,1335.1,449.2z"
          />
          <path
            style={{
              fill: '#241F20',
            }}
            d="M1428.6,434.3V488c0,3.7,0.9,6.4,2.7,8.1c1.8,1.7,4.8,2.5,9.1,2.5h13v23.6h-17.6    c-23.6,0-35.4-11.5-35.4-34.4v-53.4h-13.2v-23h13.2v-27.4h28.2v27.4h24.8v23H1428.6z"
          />
          <path
            style={{
              fill: '#241F20',
            }}
            d="M1577.1,475.2H1496c0.7,8,3.5,14.3,8.4,18.8c4.9,4.5,11,6.8,18.2,6.8c10.4,0,17.8-4.5,22.2-13.4    h30.2c-3.2,10.7-9.3,19.4-18.4,26.3c-9.1,6.9-20.2,10.3-33.4,10.3c-10.7,0-20.2-2.4-28.7-7.1c-8.5-4.7-15.1-11.4-19.8-20.1    c-4.7-8.7-7.1-18.7-7.1-30c0-11.5,2.3-21.5,7-30.2c4.7-8.7,11.2-15.3,19.6-20c8.4-4.7,18.1-7,29-7c10.5,0,20,2.3,28.3,6.8    c8.3,4.5,14.8,11,19.4,19.3c4.6,8.3,6.9,17.9,6.9,28.7C1577.9,468.4,1577.6,472,1577.1,475.2z M1548.8,456.3    c-0.1-7.2-2.7-13-7.8-17.3c-5.1-4.3-11.3-6.5-18.6-6.5c-6.9,0-12.8,2.1-17.5,6.3c-4.7,4.2-7.6,10-8.7,17.5H1548.8z"
          />
        </g>
        <g>
          <path
            style={{
              fill: '#241F20',
            }}
            d="M796.9,643.3c-3.3-1.9-6-4.5-7.9-7.9c-1.9-3.4-2.9-7.2-2.9-11.5c0-4.3,1-8.1,2.9-11.5    c1.9-3.4,4.6-6,7.9-7.9c3.3-1.9,7-2.8,11.1-2.8c4.1,0,7.8,0.9,11.1,2.8c3.3,1.9,6,4.5,7.9,7.9c1.9,3.4,2.9,7.2,2.9,11.5    c0,4.3-1,8.1-2.9,11.5c-1.9,3.4-4.5,6-7.9,7.9c-3.3,1.9-7,2.8-11.1,2.8C803.9,646.2,800.3,645.2,796.9,643.3z M816.2,639.1    c2.4-1.4,4.4-3.4,5.8-6.1c1.4-2.6,2.1-5.7,2.1-9.1c0-3.5-0.7-6.6-2.1-9.2c-1.4-2.6-3.3-4.6-5.7-6c-2.4-1.4-5.2-2.1-8.3-2.1    c-3.1,0-5.8,0.7-8.3,2.1c-2.4,1.4-4.3,3.4-5.7,6c-1.4,2.6-2.1,5.7-2.1,9.2c0,3.5,0.7,6.5,2.1,9.1c1.4,2.6,3.3,4.6,5.8,6.1    s5.2,2.1,8.2,2.1S813.8,640.5,816.2,639.1z"
          />
          <path
            style={{
              fill: '#241F20',
            }}
            d="M852.6,616.2h-7.2v29.6h-5.7v-29.6h-4.4v-4.7h4.4V609c0-3.8,1-6.6,3-8.4c2-1.8,5.2-2.7,9.5-2.7v4.8    c-2.5,0-4.3,0.5-5.3,1.5c-1,1-1.5,2.6-1.5,4.8v2.4h7.2V616.2z"
          />
          <path
            style={{
              fill: '#241F20',
            }}
            d="M904.2,636h-19l-3.5,9.7h-6l15.8-43.3h6.6l15.7,43.3h-6L904.2,636z M902.5,631.4l-7.9-22l-7.9,22    H902.5z"
          />
          <path
            style={{
              fill: '#241F20',
            }}
            d="M921.8,619.3c1.4-2.6,3.4-4.7,5.9-6.2c2.5-1.5,5.4-2.2,8.7-2.2c4.2,0,7.7,1,10.4,3.1    c2.7,2,4.5,4.9,5.4,8.5h-6.1c-0.6-2.1-1.7-3.7-3.4-4.9c-1.7-1.2-3.8-1.8-6.3-1.8c-3.3,0-5.9,1.1-7.9,3.3c-2,2.2-3,5.4-3,9.5    c0,4.1,1,7.3,3,9.6c2,2.3,4.6,3.4,7.9,3.4c2.5,0,4.6-0.6,6.3-1.8c1.7-1.2,2.8-2.8,3.4-5h6.1c-0.9,3.5-2.8,6.3-5.5,8.4    c-2.8,2.1-6.2,3.2-10.3,3.2c-3.3,0-6.1-0.7-8.7-2.2c-2.5-1.5-4.5-3.5-5.9-6.2c-1.4-2.7-2.1-5.8-2.1-9.4    C919.7,625,920.4,621.9,921.8,619.3z"
          />
          <path
            style={{
              fill: '#241F20',
            }}
            d="M985,612.5c2.1,1.1,3.7,2.8,4.9,5c1.2,2.2,1.8,4.9,1.8,8.1v20.2h-5.6v-19.4c0-3.4-0.9-6-2.6-7.9    c-1.7-1.8-4-2.7-7-2.7c-3,0-5.4,0.9-7.2,2.8c-1.8,1.9-2.7,4.6-2.7,8.2v18.9H961v-46.3h5.7v16.9c1.1-1.8,2.7-3.1,4.7-4.1    c2-1,4.2-1.4,6.7-1.4C980.6,610.8,983,611.4,985,612.5z"
          />
          <path
            style={{
              fill: '#241F20',
            }}
            d="M1002.5,604.8c-0.8-0.7-1.1-1.7-1.1-2.8c0-1.1,0.4-2,1.1-2.8c0.7-0.8,1.7-1.1,2.8-1.1    c1,0,1.9,0.4,2.7,1.1c0.7,0.8,1.1,1.7,1.1,2.8c0,1.1-0.4,2-1.1,2.8c-0.7,0.8-1.6,1.1-2.7,1.1    C1004.2,605.9,1003.2,605.5,1002.5,604.8z M1008,611.5v34.3h-5.7v-34.3H1008z"
          />
          <path
            style={{
              fill: '#241F20',
            }}
            d="M1050,630.7h-27.4c0.2,3.4,1.4,6,3.5,7.9c2.1,1.9,4.7,2.8,7.7,2.8c2.5,0,4.5-0.6,6.2-1.7    c1.6-1.1,2.8-2.7,3.5-4.6h6.1c-0.9,3.3-2.8,6-5.5,8s-6.2,3.1-10.3,3.1c-3.3,0-6.2-0.7-8.7-2.2c-2.6-1.5-4.6-3.5-6-6.2    c-1.5-2.7-2.2-5.8-2.2-9.4c0-3.5,0.7-6.6,2.1-9.3c1.4-2.7,3.4-4.7,6-6.2c2.6-1.4,5.5-2.2,8.8-2.2c3.3,0,6.1,0.7,8.6,2.1    c2.5,1.4,4.4,3.4,5.8,5.8c1.4,2.5,2,5.3,2,8.4C1050.2,628.4,1050.1,629.5,1050,630.7z M1042.9,620.5c-1-1.6-2.3-2.8-3.9-3.6    c-1.6-0.8-3.5-1.2-5.5-1.2c-2.9,0-5.3,0.9-7.3,2.8c-2,1.8-3.2,4.4-3.5,7.6h21.6C1044.3,623.9,1043.9,622.1,1042.9,620.5z"
          />
          <path
            style={{
              fill: '#241F20',
            }}
            d="M1071.7,640.5l10.6-29h6.1l-13.4,34.3h-6.6l-13.4-34.3h6.1L1071.7,640.5z"
          />
          <path
            style={{
              fill: '#241F20',
            }}
            d="M1126.4,630.7H1099c0.2,3.4,1.4,6,3.5,7.9c2.1,1.9,4.7,2.8,7.7,2.8c2.5,0,4.5-0.6,6.2-1.7    c1.6-1.1,2.8-2.7,3.5-4.6h6.1c-0.9,3.3-2.8,6-5.5,8s-6.2,3.1-10.3,3.1c-3.3,0-6.2-0.7-8.7-2.2c-2.6-1.5-4.6-3.5-6-6.2    c-1.5-2.7-2.2-5.8-2.2-9.4c0-3.5,0.7-6.6,2.1-9.3c1.4-2.7,3.4-4.7,6-6.2c2.6-1.4,5.5-2.2,8.8-2.2c3.3,0,6.1,0.7,8.6,2.1    c2.5,1.4,4.4,3.4,5.8,5.8c1.4,2.5,2,5.3,2,8.4C1126.6,628.4,1126.5,629.5,1126.4,630.7z M1119.3,620.5c-1-1.6-2.3-2.8-3.9-3.6    c-1.6-0.8-3.5-1.2-5.5-1.2c-2.9,0-5.3,0.9-7.3,2.8c-2,1.8-3.2,4.4-3.5,7.6h21.6C1120.7,623.9,1120.2,622.1,1119.3,620.5z"
          />
          <path
            style={{
              fill: '#241F20',
            }}
            d="M1183.7,612.5c2.1,1.1,3.7,2.8,4.9,5c1.2,2.2,1.8,4.9,1.8,8.1v20.2h-5.6v-19.4c0-3.4-0.8-6-2.5-7.9    c-1.7-1.8-4-2.7-6.8-2.7c-3,0-5.3,0.9-7.1,2.8c-1.8,1.9-2.6,4.6-2.6,8.2v18.9h-5.6v-19.4c0-3.4-0.8-6-2.5-7.9    c-1.7-1.8-4-2.7-6.8-2.7c-3,0-5.3,0.9-7.1,2.8c-1.8,1.9-2.6,4.6-2.6,8.2v18.9h-5.7v-34.3h5.7v4.9c1.1-1.8,2.6-3.2,4.5-4.1    c1.9-1,4-1.4,6.3-1.4c2.9,0,5.4,0.6,7.6,1.9c2.2,1.3,3.9,3.2,4.9,5.7c1-2.4,2.5-4.3,4.8-5.6c2.2-1.3,4.7-2,7.4-2    C1179.2,610.8,1181.6,611.4,1183.7,612.5z"
          />
          <path
            style={{
              fill: '#241F20',
            }}
            d="M1232.1,630.7h-27.4c0.2,3.4,1.4,6,3.5,7.9c2.1,1.9,4.7,2.8,7.7,2.8c2.5,0,4.5-0.6,6.2-1.7    c1.6-1.1,2.8-2.7,3.5-4.6h6.1c-0.9,3.3-2.8,6-5.5,8s-6.2,3.1-10.3,3.1c-3.3,0-6.2-0.7-8.7-2.2c-2.6-1.5-4.6-3.5-6-6.2    s-2.2-5.8-2.2-9.4c0-3.5,0.7-6.6,2.1-9.3c1.4-2.7,3.4-4.7,6-6.2c2.6-1.4,5.5-2.2,8.8-2.2c3.3,0,6.1,0.7,8.6,2.1    c2.5,1.4,4.4,3.4,5.8,5.8c1.4,2.5,2,5.3,2,8.4C1232.3,628.4,1232.2,629.5,1232.1,630.7z M1224.9,620.5c-1-1.6-2.3-2.8-3.9-3.6    c-1.6-0.8-3.5-1.2-5.5-1.2c-2.9,0-5.3,0.9-7.3,2.8c-2,1.8-3.2,4.4-3.5,7.6h21.6C1226.4,623.9,1225.9,622.1,1224.9,620.5z"
          />
          <path
            style={{
              fill: '#241F20',
            }}
            d="M1267.8,614.6c2.6,2.5,3.9,6.2,3.9,10.9v20.2h-5.6v-19.4c0-3.4-0.9-6-2.6-7.9c-1.7-1.8-4-2.7-7-2.7    c-3,0-5.4,0.9-7.2,2.8c-1.8,1.9-2.7,4.6-2.7,8.2v18.9h-5.7v-34.3h5.7v4.9c1.1-1.8,2.7-3.1,4.6-4.1c1.9-1,4.1-1.4,6.4-1.4    C1261.9,610.8,1265.3,612.1,1267.8,614.6z"
          />
          <path
            style={{
              fill: '#241F20',
            }}
            d="M1289.2,616.2v20.2c0,1.7,0.4,2.8,1.1,3.5c0.7,0.7,1.9,1,3.7,1h4.2v4.8h-5.1    c-3.2,0-5.5-0.7-7.1-2.2c-1.6-1.5-2.4-3.9-2.4-7.2v-20.2h-4.4v-4.7h4.4v-8.6h5.7v8.6h8.9v4.7H1289.2z"
          />
        </g>
        <path
          style={{
            fill: 'none',
          }}
          d="M453.1,1111c12.7,13.6,25.8,26.9,39.2,40C478.9,1138,465.8,1124.6,453.1,1111z"
        />
        <path
          style={{
            fill: 'none',
          }}
          d="M1497,1232.6c-14.8,11.1-29.9,21.8-45.5,32.1C1467.1,1254.4,1482.3,1243.7,1497,1232.6z"
        />
        <path
          style={{
            fill: 'none',
          }}
          d="M572.9,1221.2c3.5,2.8,7.1,5.5,10.7,8.2C580,1226.6,576.4,1223.9,572.9,1221.2z"
        />
        <path
          style={{
            fill: 'none',
          }}
          d="M590.9,1235c6.1,4.5,12.2,9,18.5,13.4C603.2,1244,597,1239.5,590.9,1235z"
        />
        <path
          style={{
            fill: 'none',
          }}
          d="M1542.2,1196.6c-10,8.4-20.1,16.7-30.5,24.8C1522.1,1213.3,1532.2,1205,1542.2,1196.6z"
        />
        <path
          style={{
            fill: 'none',
          }}
          d="M561.3,1212c-1.3-1-2.6-2.1-3.9-3.1C558.7,1210,560.1,1211,561.3,1212z"
        />
        <path
          style={{
            fill: 'none',
          }}
          d="M1572.4,1169.9c12.1-11.1,23.8-22.4,35.2-34c-6,6.1-12.1,12.1-18.3,18.1   C1583.7,1159.4,1578.1,1164.7,1572.4,1169.9z"
        />
        <path
          style={{
            fill: 'none',
          }}
          d="M1629.1,1113.7c-5.9,6.3-11.9,12.5-18,18.7C1617.2,1126.2,1623.2,1120,1629.1,1113.7z"
        />
        <path
          style={{
            fill: 'none',
          }}
          d="M483.2,1065.3c30.2-1.3,61.4-2.6,93.3-3.8C545.1,1062.7,513.9,1063.9,483.2,1065.3z"
        />
        <path
          style={{
            opacity: 0.45,
            fill: '#FFFFFF',
          }}
          d="M1888,1084.5c76.9-80.5,110-149.4,118.5-169V643c-12.2,43.9-75.3,246.5-246.1,432.5   C1804,1078.2,1846.6,1081.2,1888,1084.5z"
        />
        <path
          style={{
            opacity: 0.55,
            fill: '#FFFFFF',
          }}
          d="M2006.5,1094.6V915.5c-8.5,19.6-41.6,88.5-118.5,169   C1928.6,1087.6,1968.1,1091,2006.5,1094.6z"
        />
        <path
          style={{
            opacity: 0.35,
            fill: '#FFFFFF',
          }}
          d="M415.5,1068.6C167.9,775.3,87.5,392.8,77.1,338.9v300v0c8.9,33.4,70,242.7,245.6,434.9   C353.2,1071.9,384.1,1070.2,415.5,1068.6z"
        />
        <path
          style={{
            opacity: 0.45,
            fill: '#FFFFFF',
          }}
          d="M322.8,1073.7C147.2,881.6,86.1,672.3,77.1,638.9v274v0   c6.3,15.1,38.3,85.9,117.6,169.5C236.4,1079.3,279.1,1076.4,322.8,1073.7z"
        />
        <path
          style={{
            opacity: 0.55,
            fill: '#FFFFFF',
          }}
          d="M77.1,912.8V1092c38.1-3.4,77.4-6.6,117.6-9.6C115.4,998.7,83.4,927.9,77.1,912.8z"
        />
        <path
          style={{
            opacity: 0.35,
            fill: '#FFFFFF',
          }}
          d="M1760.4,1075.5c170.7-186,233.9-388.6,246.1-432.5V344.6   c-14.2,71-97.3,440.7-338.5,725.4C1699.3,1071.7,1730.1,1073.5,1760.4,1075.5z"
        />
        <path
          style={{
            opacity: 0.3,
            fill: '#FFFFFF',
          }}
          d="M1888,1084.5c-41.5-3.2-84-6.2-127.6-9c-130,141.7-322.5,273.7-602.3,318.7h35.7   C1563.3,1348.5,1773.9,1203.9,1888,1084.5z"
        />
        <path
          style={{
            opacity: 0.4,
            fill: '#FFFFFF',
          }}
          d="M1193.8,1394.2h812.7v-263.5v-36.1c-38.4-3.6-77.9-7-118.5-10.1   C1773.9,1203.9,1563.3,1348.5,1193.8,1394.2z"
        />
        <path
          style={{
            opacity: 0.2,
            fill: '#FFFFFF',
          }}
          d="M918.4,1387.8c-7.9-1.8-15.7-3.8-23.5-5.8c-1.5-0.4-2.9-0.8-4.4-1.2   c-8-2.1-15.9-4.4-23.8-6.7c-0.2-0.1-0.4-0.1-0.6-0.2c-7.8-2.3-15.5-4.8-23.1-7.3c-1.2-0.4-2.5-0.8-3.8-1.2   c-7.5-2.5-14.9-5.1-22.3-7.8c-1.3-0.5-2.6-1-3.9-1.4c-7.6-2.8-15.1-5.7-22.5-8.7c-0.2-0.1-0.4-0.2-0.6-0.3c-7.4-3-14.8-6.1-22-9.3   c-0.9-0.4-1.9-0.8-2.8-1.2c-7.2-3.2-14.3-6.4-21.4-9.8c-1.1-0.5-2.1-1-3.2-1.5c-7.2-3.4-14.4-7-21.4-10.6c-0.1-0.1-0.2-0.1-0.4-0.2   c-7.2-3.7-14.3-7.5-21.3-11.3c-0.6-0.3-1.2-0.6-1.8-1c-6.9-3.8-13.7-7.7-20.5-11.7c-0.8-0.5-1.6-0.9-2.4-1.4   c-6.9-4.1-13.7-8.2-20.5-12.4c0,0,0,0,0,0c-7-4.4-13.9-8.8-20.7-13.4c-0.3-0.2-0.5-0.3-0.8-0.5c-6.6-4.4-13.2-8.9-19.6-13.5   c-0.6-0.4-1.2-0.8-1.8-1.2c-6.2-4.4-12.4-8.9-18.5-13.4c-2.5-1.8-4.9-3.7-7.4-5.6c-3.6-2.7-7.2-5.4-10.7-8.2   c-0.8-0.7-1.7-1.3-2.6-2c-3-2.4-6-4.8-8.9-7.2c-1.3-1-2.6-2.1-3.9-3.1c-5.2-4.2-10.3-8.5-15.4-12.8c-1-0.8-2-1.7-3-2.5   c-3.5-3-7-6-10.4-9c-1.1-1-2.3-2-3.4-3c-4.3-3.8-8.6-7.7-12.9-11.6c-6.8-6.2-13.4-12.5-20-18.9c0,0,0,0,0,0c0,0,0,0,0,0   c-13.5-13-26.6-26.4-39.2-40c-0.2-0.2-0.4-0.5-0.7-0.7c-5.9-6.4-11.8-12.8-17.5-19.3c-1-1.1-1.9-2.2-2.9-3.2   c-5.6-6.4-11.2-12.8-16.6-19.2c0,0,0,0-0.1-0.1c-31.4,1.6-62.3,3.3-92.7,5.2c130,142.3,322.9,275.3,603.9,320.4h21.1   c-8.4-1.7-16.7-3.5-24.9-5.4C921.3,1388.5,919.9,1388.2,918.4,1387.8z"
        />
        <path
          style={{
            opacity: 0.3,
            fill: '#FFFFFF',
          }}
          d="M322.8,1073.7c-43.7,2.6-86.4,5.5-128,8.6c113.7,119.8,324.6,265.9,696.2,311.8h35.7   C645.7,1349,452.8,1216.1,322.8,1073.7z"
        />
        <path
          style={{
            opacity: 0.4,
            fill: '#FFFFFF',
          }}
          d="M194.8,1082.4c-40.2,3-79.5,6.2-117.6,9.6v38.7v263.5h813.8   C519.3,1348.3,308.4,1202.2,194.8,1082.4z"
        />
        <path
          style={{
            opacity: 0.2,
            fill: '#FFFFFF',
          }}
          d="M1760.4,1075.5c-30.3-1.9-61.1-3.7-92.4-5.4c-5.6,6.6-11.4,13.2-17.1,19.8   c-0.9,1-1.7,2-2.6,3c-5.8,6.5-11.7,13-17.7,19.4c-0.5,0.5-1,1-1.5,1.6c-5.9,6.3-11.9,12.5-18,18.7c-1.2,1.2-2.3,2.3-3.5,3.5   c-11.4,11.5-23.2,22.9-35.2,34c-4.4,4.1-8.9,8.1-13.5,12.1c-1,0.9-2,1.8-3.1,2.7c-4,3.5-8.1,7.1-12.2,10.5c-0.5,0.4-1,0.9-1.5,1.3   c-9.9,8.4-20.1,16.7-30.5,24.8c0,0,0,0,0,0s0,0,0,0c-4.8,3.8-9.7,7.5-14.6,11.2c-14.8,11.1-29.9,21.8-45.5,32.1   c-0.2,0.1-0.4,0.3-0.7,0.4c-13.6,9-27.6,17.7-41.8,26c-0.3,0.2-0.5,0.3-0.8,0.5c-7,4.1-14,8-21.1,11.9c-0.6,0.3-1.1,0.6-1.7,0.9   c-14.2,7.7-28.7,15.1-43.5,22.1c-0.7,0.3-1.4,0.7-2.1,1c-7.1,3.4-14.4,6.6-21.7,9.8c-0.9,0.4-1.9,0.8-2.8,1.2   c-14.7,6.4-29.8,12.4-45.1,18.1c-1.1,0.4-2.2,0.8-3.3,1.2c-7.4,2.7-14.8,5.3-22.3,7.8c-1.3,0.4-2.6,0.8-3.9,1.3   c-7.7,2.5-15.5,5-23.4,7.4c0,0,0,0,0,0c-7.8,2.3-15.7,4.5-23.7,6.6c-1.4,0.4-2.8,0.8-4.3,1.1c-7.7,2-15.5,3.9-23.3,5.8   c-1.5,0.4-3,0.7-4.5,1c-8.1,1.9-16.3,3.6-24.6,5.3c0,0,0,0,0,0h21.1C1438,1349.2,1630.4,1217.1,1760.4,1075.5z"
        />
        <path
          style={{
            opacity: 0.05,
            fill: '#241F20',
          }}
          d="M1174,1065.6l3.7,2.5c7.4,5.1,9.2,15.3,4,22.6l-2.6,3.6c-4,5.6-4,13.1,0,18.7   l2.6,3.6c1.6,2.3,2.5,4.8,2.8,7.4c151.2,5,297.1,16.8,404.8,29.8c6.2-6,12.3-12,18.3-18.1c1.2-1.2,2.3-2.3,3.5-3.5   c6.1-6.2,12.1-12.4,18-18.7c0.5-0.5,1-1,1.5-1.6c6-6.4,11.9-12.9,17.7-19.4c0.9-1,1.7-2,2.6-3c5.8-6.5,11.5-13.1,17.1-19.8   c0,0,0,0,0,0c-152.9-8.3-316.7-13.1-487.6-15.7c-4.7-0.1-9.3-0.1-13.2-0.2C1167.7,1058.7,1170.1,1063,1174,1065.6z"
        />
        <path
          style={{
            opacity: 0.05,
            fill: '#241F20',
          }}
          d="M432.1,1087.8c1,1.1,1.9,2.2,2.9,3.2c5.8,6.5,11.6,12.9,17.5,19.3   c0.2,0.2,0.4,0.5,0.7,0.7c12.7,13.6,25.8,26.9,39.2,40c0,0,0,0,0,0c109.2-12.9,238.2-23.9,406.9-27.9c0.4-2.2,1.3-4.4,2.7-6.4   l2.6-3.6c4-5.6,4-13.2,0-18.7l-2.6-3.6c-5.3-7.3-3.5-17.5,4-22.6l3.7-2.5c4-2.7,6.4-7.1,6.9-11.7c-7.9,0-15.9,0.1-17.1,0.1   c-103.9,1-205.3,3.3-303.3,6.7c-6.6,0.2-13.1,0.5-19.7,0.7c-31.9,1.2-63.2,2.5-93.3,3.8c-7.7,0.3-15.5,0.7-23.1,1.1   c-0.5,0-1,0-1.4,0.1c-6.7,0.3-13.3,0.6-19.9,1c-7.8,0.4-15.6,0.8-23.3,1.2c0,0,0,0,0.1,0.1C421,1075.1,426.5,1081.5,432.1,1087.8z"
        />
        <path
          style={{
            opacity: 0.15,
            fill: '#241F20',
          }}
          d="M1184.5,1124.2c0.7,5.8-1.7,11.7-6.8,15.2l-3.7,2.5c-5.7,3.9-8.3,10.9-6.4,17.6   l1.2,4.3c2.4,8.7-2.8,17.7-11.5,19.9l-4.3,1.1c-6.6,1.7-11.4,7.4-12,14.3c132.2,3.1,263,11.7,370.7,22.3c0,0,0,0,0,0   c10.3-8.1,20.5-16.4,30.5-24.8c0.5-0.4,1-0.9,1.5-1.3c4.1-3.5,8.2-7,12.2-10.5c1-0.9,2.1-1.8,3.1-2.7c4.5-4,9-8,13.5-12.1   c5.7-5.2,11.3-10.6,16.9-15.9C1481.6,1141,1335.8,1129.2,1184.5,1124.2z"
        />
        <path
          style={{
            opacity: 0.15,
            fill: '#241F20',
          }}
          d="M930.7,1184.8l-4.3-1.1c-8.7-2.2-13.9-11.2-11.5-19.9l1.2-4.3   c1.9-6.7-0.7-13.7-6.4-17.6l-3.7-2.5c-5.4-3.7-7.8-10.2-6.7-16.2c-168.7,3.9-297.7,14.9-406.9,27.9c0,0,0,0,0,0   c6.6,6.4,13.2,12.7,20,18.9c4.2,3.9,8.5,7.8,12.9,11.6c1.1,1,2.3,2,3.4,3c3.4,3,6.9,6.1,10.4,9c1,0.8,2,1.7,3,2.5   c5.1,4.3,10.2,8.6,15.4,12.8c1.3,1,2.6,2.1,3.9,3.1c3,2.4,5.9,4.8,8.9,7.2c102-10.2,222-18.1,372.3-20.5   C941.9,1192,937.2,1186.5,930.7,1184.8z"
        />
        <path
          style={{
            opacity: 0.25,
            fill: '#241F20',
          }}
          d="M1161.7,1388.9c1.5-0.3,3-0.7,4.5-1c7.8-1.8,15.6-3.8,23.3-5.8   c1.4-0.4,2.9-0.8,4.3-1.1c8-2.1,15.9-4.3,23.7-6.6c0,0,0,0,0,0c7.9-2.3,15.7-4.8,23.4-7.4c1.3-0.4,2.6-0.8,3.9-1.3   c7.5-2.5,14.9-5.1,22.3-7.8c1.1-0.4,2.2-0.8,3.3-1.2c15.3-5.7,30.4-11.7,45.1-18.1c0.9-0.4,1.9-0.8,2.8-1.2   c7.3-3.2,14.5-6.5,21.7-9.8c0.7-0.3,1.4-0.7,2.1-1c14.8-7,29.3-14.4,43.5-22.1c0.6-0.3,1.1-0.6,1.7-0.9c7.1-3.9,14.1-7.9,21.1-11.9   c0.3-0.2,0.5-0.3,0.8-0.5c14.3-8.3,28.2-17,41.8-26c0.2-0.1,0.4-0.3,0.7-0.4c15.6-10.3,30.7-21,45.5-32.1   c4.9-3.7,9.8-7.4,14.6-11.2c0,0,0,0,0,0c-107.7-10.5-238.5-19.2-370.7-22.3c0,0,0,0.1,0,0.1l-0.4,4.4c-0.7,9-8.6,15.7-17.6,14.8   l-4.4-0.4c-1.7-0.2-3.3-0.1-4.9,0.2c1,4.3,2,8.6,3,12.9c3.8,16.9,7.7,33.7,11.6,50.6c1,4.3,1.9,8.7,3,13.5   c-11.1-4.4-21.4-8.5-31.7-12.7c-3.1-1.3-5.5-1.2-7.8,1.3c-3.6,4-7.6,7.6-11.4,11.4c-3.7,3.7-7.5,7.3-11.9,11.5   c-4.9-21.3-9.7-42.4-14.6-63.5l-0.5,0.5c-6.3,6.5-16.7,6.5-23,0l-1.2-1.3c-4.9,21.3-9.8,42.6-14.8,64.2c-4.4-4.3-8.2-7.9-11.9-11.5   c-3.8-3.8-7.8-7.4-11.4-11.4c-2.3-2.5-4.7-2.6-7.8-1.3c-10.3,4.2-20.6,8.3-31.7,12.7c1.1-4.8,2-9.1,3-13.5   c3.9-16.9,7.8-33.7,11.6-50.6c1-4.3,2-8.6,3-13c-1.3-0.2-2.6-0.3-4-0.1l-4.4,0.4c-9,0.9-16.9-5.8-17.6-14.8l-0.3-4.4   c0-0.2-0.1-0.4-0.1-0.5c-150.4,2.4-270.3,10.3-372.3,20.5c0.8,0.7,1.7,1.3,2.6,2c3.5,2.8,7.1,5.5,10.7,8.2c2.5,1.9,4.9,3.8,7.4,5.6   c6.1,4.5,12.2,9,18.5,13.4c0.6,0.4,1.2,0.8,1.8,1.2c6.5,4.6,13,9,19.6,13.5c0.3,0.2,0.5,0.3,0.8,0.5c6.8,4.5,13.7,9,20.7,13.4   c0,0,0,0,0,0c6.7,4.2,13.6,8.3,20.5,12.4c0.8,0.5,1.6,1,2.4,1.4c6.8,4,13.6,7.9,20.5,11.7c0.6,0.3,1.2,0.6,1.8,1   c7,3.9,14.1,7.6,21.3,11.3c0.1,0.1,0.2,0.1,0.4,0.2c7.1,3.6,14.2,7.1,21.4,10.6c1.1,0.5,2.1,1,3.2,1.5c7.1,3.3,14.2,6.6,21.4,9.8   c0.9,0.4,1.9,0.8,2.8,1.2c7.3,3.2,14.6,6.3,22,9.3c0.2,0.1,0.4,0.2,0.6,0.3c7.4,3,14.9,5.9,22.5,8.7c1.3,0.5,2.6,1,3.9,1.4   c7.4,2.7,14.8,5.3,22.3,7.8c1.2,0.4,2.5,0.8,3.8,1.2c7.6,2.5,15.3,5,23.1,7.3c0.2,0.1,0.4,0.1,0.6,0.2c7.8,2.3,15.8,4.6,23.8,6.7   c1.5,0.4,2.9,0.8,4.4,1.2c7.8,2,15.6,4,23.5,5.8c1.5,0.3,2.9,0.7,4.4,1c8.2,1.9,16.5,3.7,24.9,5.4H1137c0,0,0,0,0,0   C1145.3,1392.5,1153.5,1390.7,1161.7,1388.9z"
        />
        <path
          style={{
            opacity: 0.97,
            fill: '#FFFFFF',
          }}
          d="M-0.4,0.4l-0.9,1471.5h2085.7l0.5-1472.5L-0.4,0.4z M2006.5,344.6V643v272.5v179.1   v36.1v263.5h-812.7h-35.7H1137H947.7h-21.1h-35.7H77.1v-263.5V1092V912.8v0v-274v0v-300c0,0,0,0,0,0v-262h1929.4V344.6z"
        />
        <path
          style={{
            opacity: 0.75,
            fill: '#241F20',
          }}
          d="M1049,1222.4c1.6,7,3.2,13.9,4.8,20.9l0,0c4.8,21.1,9.7,42.2,14.6,63.5   c4.4-4.3,8.2-7.9,11.9-11.5c3.8-3.8,7.8-7.4,11.4-11.4c2.3-2.5,4.7-2.6,7.8-1.3c10.3,4.2,20.6,8.3,31.7,12.7c-1.1-4.8-2-9.1-3-13.5   c-3.9-16.9-7.8-33.7-11.6-50.6c-1-4.3-2-8.5-3-12.9c-1.3-5.7-2.6-11.4-3.9-17.1C1092.4,1213.4,1071.6,1221,1049,1222.4z"
        />
        <path
          style={{
            opacity: 0.55,
            fill: '#241F20',
          }}
          d="M1049,1222.4c-2.4,0.1-4.8,0.2-7.2,0.2c-2.7,0-5.4-0.1-8.1-0.3   c-1.6,6.7-3.1,13.5-4.7,20.2v0l1.2,1.3c6.3,6.5,16.7,6.5,23,0l0.5-0.5l0,0C1052.2,1236.3,1050.6,1229.3,1049,1222.4z"
        />
        <path
          style={{
            opacity: 0.45,
            fill: '#FFFFFF',
          }}
          d="M1074.3,1180.7c5-2.1,9.7-4.7,14.2-7.7c22.2-15,36.8-40.4,36.8-69.3   c0-28.8-14.6-54.2-36.8-69.2c-4.4-3-9.2-5.6-14.2-7.7c-10-4.2-21-6.6-32.5-6.6c-14.4,0-28,3.7-39.8,10.1   c-7.1,3.9-13.6,8.7-19.2,14.4c-15.1,15.1-24.5,36-24.5,59c0,23.1,9.3,44,24.5,59.1c5.7,5.7,12.1,10.5,19.2,14.4   c11.8,6.4,25.4,10.1,39.8,10.1C1053.4,1187.3,1064.3,1185,1074.3,1180.7z M1008.9,1148.2c-0.5-0.4-0.7-1-0.6-1.7l6-34.7l-26-25.3   c-0.4-0.4-0.5-0.9-0.3-1.3c0.1-0.4,0.5-0.8,1-0.8l35.9-5.2l15.9-32.3c0.3-0.5,0.8-0.8,1.3-0.7c0.4,0,0.9,0.3,1.1,0.7l15.9,32.3   l35.2,5.1c0.6,0.1,1.1,0.6,1.3,1.1c0.2,0.6,0.1,1.2-0.4,1.7l-25.5,24.8l6.1,35.5c0.1,0.6-0.1,1.1-0.5,1.3c-0.4,0.4-1,0.4-1.5,0.1   L1042,1132l-31.2,16.4C1010.2,1148.8,1009.4,1148.7,1008.9,1148.2z"
        />
        <path
          style={{
            opacity: 0.75,
            fill: '#FFFFFF',
          }}
          d="M1073.9,1148.7c0.6,0.3,1.1,0.2,1.5-0.1c0.4-0.3,0.6-0.8,0.5-1.3l-6.1-35.5l25.5-24.8   c0.5-0.5,0.6-1.1,0.4-1.7c-0.2-0.5-0.6-1-1.3-1.1l-35.2-5.1l-15.9-32.3c-0.2-0.5-0.7-0.7-1.1-0.7c-0.5,0-1.1,0.2-1.3,0.7   l-15.9,32.3l-35.9,5.2c-0.5,0.1-0.9,0.4-1,0.8c-0.1,0.4-0.1,0.9,0.3,1.3l26,25.3l-6,34.7c-0.1,0.7,0.1,1.3,0.6,1.7   c0.5,0.4,1.3,0.6,1.9,0.2l31.2-16.4L1073.9,1148.7z"
        />
        <path
          style={{
            opacity: 0.75,
            fill: '#241F20',
          }}
          d="M1033.7,1222.3c-22.5-1.5-43.3-9.3-60.7-21.6c-0.1,0.6-0.3,1.2-0.4,1.8   c-1.2,5.2-2.4,10.4-3.6,15.7c-1,4.3-2,8.6-3,13c-3.8,16.9-7.7,33.7-11.6,50.6c-1,4.3-1.9,8.7-3,13.5c11.1-4.4,21.4-8.5,31.7-12.7   c3.1-1.3,5.5-1.2,7.8,1.3c3.6,4,7.6,7.6,11.4,11.4c3.7,3.7,7.5,7.3,11.9,11.5c4.9-21.6,9.9-42.9,14.8-64.2v0   C1030.6,1235.8,1032.2,1229,1033.7,1222.3z"
        />
        <path
          style={{
            opacity: 0.2,
            fill: '#FFFFFF',
          }}
          d="M1041.8,1194.9c0.3,0,0.6,0,0.9,0c18.2-0.2,35.2-5.7,49.4-15.1   c24.6-16.3,40.9-44.3,40.9-76c0-50.3-40.8-91.2-91.2-91.2s-91.2,40.8-91.2,91.2c0,31.9,16.5,60,41.3,76.3   c13.8,9.1,30.3,14.5,48.1,14.8C1040.6,1194.9,1041.2,1194.9,1041.8,1194.9z M982.8,1162.8c-15.1-15.1-24.5-36-24.5-59.1   c0-23.1,9.3-43.9,24.5-59c5.7-5.7,12.1-10.5,19.2-14.4c11.8-6.4,25.4-10.1,39.8-10.1c11.5,0,22.5,2.3,32.5,6.6   c5,2.1,9.7,4.7,14.2,7.7c22.2,15,36.8,40.4,36.8,69.2c0,28.8-14.6,54.3-36.8,69.3c-4.4,3-9.2,5.6-14.2,7.7c-10,4.2-21,6.6-32.5,6.6   c-14.4,0-28-3.7-39.8-10.1C994.9,1173.4,988.4,1168.5,982.8,1162.8z"
        />
        <path
          style={{
            opacity: 0.55,
            fill: '#241F20',
          }}
          d="M909.6,1065.6l-3.7,2.5c-7.4,5.1-9.2,15.3-4,22.6l2.6,3.6c4,5.6,4,13.1,0,18.7   l-2.6,3.6c-1.4,2-2.3,4.2-2.7,6.4c-1.1,6.1,1.2,12.5,6.7,16.2l3.7,2.5c5.7,3.9,8.3,10.9,6.4,17.6l-1.2,4.3   c-2.4,8.7,2.8,17.7,11.5,19.9l4.3,1.1c6.5,1.6,11.2,7.2,12,13.8c0,0.2,0.1,0.4,0.1,0.5l0.3,4.4c0.7,9,8.6,15.7,17.6,14.8l4.4-0.4   c1.3-0.1,2.6-0.1,4,0.1c1.2-5.2,2.4-10.4,3.6-15.7c0.1-0.6,0.3-1.2,0.4-1.8c-2.8-2-5.5-4.1-8.1-6.4c-0.9-0.8-1.9-1.5-2.7-2.3   c-5.2-4.7-9.9-9.8-14.2-15.2c-2.9-3.7-5.5-7.5-7.9-11.5c-2.4-4-4.6-8.1-6.5-12.4c-6.8-14.9-10.6-31.6-10.6-49.1   c0-65.6,53.2-118.8,118.8-118.8c65.6,0,118.8,53.2,118.8,118.8c0,2.5-0.1,5-0.2,7.5c-0.3,5-0.9,9.8-1.8,14.6   c-0.9,4.8-2.1,9.5-3.5,14c-2.9,9.1-6.9,17.8-11.8,25.8c-4.9,8-10.7,15.4-17.3,22c-2.5,2.5-5.2,4.9-8,7.2c-0.8,0.7-1.6,1.4-2.5,2.1   c-1.8,1.4-3.7,2.8-5.6,4.2c1.3,5.7,2.6,11.4,3.9,17.1c1.6-0.3,3.2-0.4,4.9-0.2l4.4,0.4c9,0.9,16.9-5.8,17.6-14.8l0.4-4.4   c0,0,0-0.1,0-0.1c0.6-6.8,5.4-12.6,12-14.3l4.3-1.1c8.8-2.2,13.9-11.2,11.5-19.9l-1.2-4.3c-1.9-6.7,0.7-13.7,6.4-17.6l3.7-2.5   c5.1-3.5,7.5-9.5,6.8-15.2c-0.3-2.6-1.2-5.1-2.8-7.4l-2.6-3.6c-4-5.6-4-13.2,0-18.7l2.6-3.6c5.3-7.3,3.5-17.5-4-22.6l-3.7-2.5   c-4-2.7-6.4-6.9-6.9-11.4c-0.2-1.5-0.1-2.9,0.1-4.4c0.1-0.6,0.2-1.2,0.3-1.7l1.2-4.3c2.4-8.7-2.8-17.7-11.5-19.9l-4.3-1.1   c-6.7-1.7-11.5-7.5-12-14.4l-0.4-4.4c-0.7-9-8.6-15.7-17.6-14.8l-4.4,0.4c-6.8,0.7-13.4-3.1-16.2-9.4l-1.8-4.1   c-3.7-8.2-13.4-11.8-21.6-7.9l-4,1.9c-6.2,3-13.7,1.7-18.5-3.2l-3.1-3.2c-6.3-6.5-16.7-6.5-23,0l-3.1,3.2   c-4.8,4.9-12.3,6.2-18.5,3.2l-4-1.9c-8.2-3.9-17.9-0.4-21.6,7.9l-1.8,4.1c-2.9,6.3-9.4,10.1-16.2,9.4l-4.4-0.4   c-9-0.9-16.9,5.8-17.6,14.8l-0.3,4.4c-0.5,6.9-5.4,12.7-12,14.4l-4.3,1.1c-8.7,2.2-13.9,11.2-11.5,19.9l1.2,4.3   c0.1,0.3,0.1,0.5,0.2,0.8c0.4,1.7,0.5,3.4,0.3,5.1C916.1,1058.6,913.6,1062.9,909.6,1065.6z"
        />
        <path
          style={{
            opacity: 0.15,
            fill: '#241F20',
          }}
          d="M1041.8,1222.6c2.4,0,4.8-0.1,7.2-0.2c22.6-1.3,43.4-9,60.8-21.2   c1.9-1.3,3.8-2.7,5.6-4.2c0.8-0.7,1.6-1.4,2.5-2.1c2.8-2.3,5.5-4.7,8-7.2c6.6-6.6,12.4-14,17.3-22c4.9-8,8.9-16.6,11.8-25.8   c1.5-4.6,2.6-9.2,3.5-14c0.9-4.8,1.5-9.7,1.8-14.6c0.2-2.5,0.2-5,0.2-7.5c0-65.6-53.2-118.8-118.8-118.8   c-65.6,0-118.8,53.2-118.8,118.8c0,17.5,3.8,34.1,10.6,49.1c1.9,4.3,4.1,8.4,6.5,12.4c2.4,4,5.1,7.8,7.9,11.5   c4.3,5.5,9,10.6,14.2,15.2c0.9,0.8,1.8,1.6,2.7,2.3c2.6,2.2,5.3,4.4,8.1,6.4c17.4,12.3,38.2,20.1,60.7,21.6   C1036.4,1222.5,1039.1,1222.6,1041.8,1222.6z M950.7,1103.8c0-50.3,40.8-91.2,91.2-91.2s91.2,40.8,91.2,91.2   c0,31.8-16.3,59.7-40.9,76c-14.2,9.4-31.1,14.9-49.4,15.1c-0.3,0-0.6,0-0.9,0c-0.6,0-1.2,0-1.8-0.1c-17.8-0.3-34.2-5.7-48.1-14.8   C967.1,1163.8,950.7,1135.7,950.7,1103.8z"
        />
      </g>
      <g id="Course_Name">
        <g>
          <rect
            x={471.8}
            y={901.3}
            style={{
              fill: '#231F20',
            }}
            width={1134.9}
            height={2.1}
          />
        </g>
      </g>
      <g id="Learner_Name">
        <g>
          <rect
            x={471.8}
            y={784.9}
            style={{
              fill: '#231F20',
            }}
            width={713.7}
            height={2.1}
          />
        </g>
      </g>
      <g id="Date">
        <rect
          x={1230.8}
          y={784.9}
          style={{
            fill: '#231F20',
          }}
          width={376}
          height={2.1}
        />
      </g>
    </svg>
  );
};
